import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrowdctrlFormatDatePipe } from '../../pipes/crowdctrl-format-date.pipe';

@Component({
  selector: 'crowdctrl-pagination-footer',
  standalone: true,
  imports: [CommonModule, CrowdctrlFormatDatePipe],
  templateUrl: './pagination-footer.component.html',
  styleUrl: './pagination-footer.component.css',
})
export class PaginationFooterComponent {
  @Input() currentCount!: number;
  @Input() totalCount?: number;
  @Input() pageSize!: number;
  @Input() retrievedAt: string | Date | null | undefined;
  @Input() itemType!: string;
  /** Live-update retrieval status label displayed after Retrieved time. */
  @Input() liveUpdatesStatus: 'off' | 'connected' | 'disconnected' = 'off';
  /** Where projected content (e.g. live-updates badge) sits relative to the count text. */
  @Input() extraSlot: 'start' | 'end' = 'end';
  /**
   * Deprecated display flag retained for backwards compatibility at call sites.
   */
  @Input() showRefreshHint = true;

  get liveUpdatesStatusText(): string {
    switch (this.liveUpdatesStatus) {
      case 'connected':
        return 'Live updates connected';
      case 'disconnected':
        return 'Live updates disconnected';
      case 'off':
      default:
        return 'Live updates off';
    }
  }
}
